import { render } from "./BlockNav.vue?vue&type=template&id=e0793c40&scoped=true"
import script from "./BlockNav.vue?vue&type=script&lang=js"
export * from "./BlockNav.vue?vue&type=script&lang=js"

import "./BlockNav.vue?vue&type=style&index=0&id=e0793c40&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0793c40"]])

export default __exports__